import { UnitLeaseResident } from '@/models/features'

/** Same rule the backend uses for the units CSV export. */
export const getLeaseHolder = (residents: UnitLeaseResident[]) =>
  residents.find(({ isHeadOfHousehold }) => isHeadOfHousehold) ??
  residents.find(({ isLeaseSigner }) => isLeaseSigner) ??
  residents[0] ??
  null

export const getResidentFullName = ({ firstName, lastName }: UnitLeaseResident) =>
  [firstName, lastName].filter(Boolean).join(' ')

export const sortLeaseResidents = (residents: UnitLeaseResident[]) => {
  const leaseHolder = getLeaseHolder(residents)

  return [...residents].sort((a, b) => {
    if (a === leaseHolder) return -1
    if (b === leaseHolder) return 1

    return getResidentFullName(a).localeCompare(getResidentFullName(b))
  })
}
